import { MicroDroits } from "./micro.droits";
import { User } from "./user";

export class Profile {

    public user: User;

    public microDroits: MicroDroits;

    /**
     * Compare profiles
     * 
     * @param profile a profile
     * @param otherProfile another profile
     * @returns a number < 0 if profile is "smaller" that otherProfile
     */
    public static compare(profile: Profile, otherProfile: Profile): number {
        if (profile.user === null) {
            return 1
        } else if (otherProfile.user === null) {
            return -1
        }

        return User.compare(profile.user, otherProfile.user)
    }

    /**
     * Compare profiles and returns the smallest one
     * 
     * @param profile a profile
     * @param otherProfile another profile
     * @returns the smallest of the two profiles
     */
    private static minOfTwo(profile: Profile, otherProfile: Profile): Profile {
        return Profile.compare(profile, otherProfile) < 0 ? profile : otherProfile
    }

    /**
     * Get the smallest profile from an array
     * 
     * @param profiles an non-empty array of profiles 
     * @returns the smallest profile
     */
    public static min(profiles: Array<Profile>): Profile {
        return profiles.reduce(Profile.minOfTwo)
    }
}